import { RadioOption } from '../../widget-ui-toolkit/RadioButton/types';

export enum BookingFlowViews {
  Main,
  Calendar,
  FullyBooked,
  Loading,
  Confirmation,
  CarerUnavailable,
  CarerDeactivated,
}

export type CalendarViewProps = {
  nhsPatientSelectorEnabled?: boolean;
  nhsAdultPatientViewEnabled?: boolean;
  nhsChildPatientViewEnabled?: boolean;
};

export type BookingState = {
  timeSlot: Date | undefined;

  patientNhsNumber?: string;
  patientName?: string;
  patientDateOfBirth?: string;
  patientGender?: string;
  phoneNumber: string;

  optionalNotes?: string;
  optionChecked: boolean;

  isChild?: boolean;
  legalGuradianNhsNumber?: string;
  legalGuardianCheckboxChecked: boolean;
  professionId?: string;
};

export type MainViewProps = {
  booking: BookingState;
  onChangeBooking: (booking: BookingState) => void;
  onSelectNewAppointmentDateTime: () => void;
  appointmentDateTime: Date;
  onBookAppointment: () => void;
  isSlotUnavailable: boolean;
  partnership: string;
  patientTypeOption: RadioOption;
  setPatientTypeOption: (value: RadioOption) => void;
  showNurse: boolean;
};

export type PracticeSettingsProps = {
  isAppointmentListEnabled: boolean;
  partnership: string;
  isNurseBookingEnabled: boolean;
};

export enum MainSubViews {
  Booking,
  NurseUnavailable,
  null,
}
